module.exports = __webpack_public_path__ + "static/storm_sphere-f383c022e3bc9ead20c3739de24058d0.jpg";